import { render, staticRenderFns } from "./TableUserLogs.vue?vue&type=template&id=695825a3&"
import script from "./TableUserLogs.vue?vue&type=script&lang=js&"
export * from "./TableUserLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports